import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { twJoin } from "tailwind-merge";

import { Icon } from "src/base-components/Icon";
import { UserNameInfo } from "src/flowContainer/versionEditedInfo/UsernameInfo";
import { useAuthoringContext } from "src/router/routerContextHooks";
import { formatDate } from "src/utils/datetime";

type RevisionHeaderProps = {
  changedBy: string | undefined;
  includeBreadcrumb?: boolean;
};

export const RevisionHeader: React.FC<RevisionHeaderProps> = ({
  changedBy,
  includeBreadcrumb = false,
}) => {
  const { version, flow } = useAuthoringContext();

  return (
    <div
      className={twJoin(
        "flex flex-row items-center gap-x-1 text-lg",
        includeBreadcrumb && "ml-3",
      )}
    >
      {includeBreadcrumb && (
        <>
          <div className="font-inter-semibold-14px text-gray-800">
            {flow.name}
          </div>
          <div className="mr-0.5 ml-1.5">
            <Icon
              color="text-gray-500 hover:text-gray-700"
              icon={faChevronRight}
              size="3xs"
            />
          </div>
        </>
      )}
      <div className="font-inter-semibold-13px text-gray-800">
        {version.name}
      </div>
      <div className="font-inter-normal-13px text-gray-500">at</div>

      <div className="font-inter-semibold-13px text-gray-800">
        {formatDate(version.updated_at, "dd MMM yyyy HH:mmaaa")}
      </div>
      <div className="font-inter-normal-13px text-gray-500">by</div>
      {changedBy !== undefined && (
        <div className="flex font-inter-semibold-13px text-gray-800">
          <UserNameInfo userId={changedBy} withAvatar={true} />
        </div>
      )}
    </div>
  );
};
